import styled from "styled-components";
import { Colors } from "../../../../../../constants/Colors";

export const PickTimeContainer = styled.div`
    flex: 1;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding-top: 4rem;
`;

export const TimeSelection = styled.div`
    background-color: ${Colors.primary[100]};

    height: 130px;
    width: 380px;

    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 200px;

    padding: 2rem;

    p {
        margin: 0;
    }
`;

export const MinutesField = styled.div`
    font-size: 6rem;
`;

export const JustFlex = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    font-size: 1.5rem;
`;

export const TotalValue = styled.div`
    color: ${Colors.primary[100]};
    height: 40%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 2rem;
    
    p {
        margin: 0;
        font-size: 4rem;
        font-weight: 500;
    }
`;